import { render, staticRenderFns } from "./CookiePrivacyLink.vue?vue&type=template&id=468403b8&"
import script from "./CookiePrivacyLink.vue?vue&type=script&lang=js&"
export * from "./CookiePrivacyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports